import type { IKeyValueStorage } from './storage';

export async function clearStoragePreservingKeys(
  keys: readonly string[],
  storage: Pick<IKeyValueStorage, 'multiGet' | 'multiSet' | 'clear'>,
): Promise<void> {
  const saved = await storage.multiGet([...keys]);
  await storage.clear();
  const toRestore = saved.filter((e): e is [string, string] => e[1] !== null);
  if (toRestore.length > 0) {
    await storage.multiSet(toRestore);
  }
}
